import './plug.scss';

function Plug({ children }) {
  return (
    <div className='plug' role='img'>
      {children}
    </div>
  );
}

export default Plug;
